import React from 'react';
import { bool, func, instanceOf, string } from 'prop-types';
import { useProductDeprecated } from "@thd-nucleus/data-sources/react/dataModel/migration";
import { Col, Row } from '@thd-olt-component-react/grid';
import { Button } from '@thd-olt-component-react/button';
import { Rating } from '@thd-olt-component-react/rating';
import './Overview.style.scss';
import classNames from 'classnames';
import { Histogram } from '@thd-olt-component-react/histogram';
import { RatingsAndReviewsMobileHeader } from '../Mobile/RatingsAndReviewsMobileHeader';
import { usePresentation } from '../../context/PresentationProvider';
import { WriteAReview } from '../WriteAReview/WriteAReview.component';
import { dataModel } from "../ReviewDataModel";
import ReviewHelper from '../Review/helpers/ReviewHelper';

// TODO: Rescope CSS
export const Overview = ({ apiKey, isMobileOverlay, itemId, reviewStatistics, filterCheckboxes, onFilterChange, selectedSentiment, clickableFilters, hideSecondaryRatings, handleCardClick }) => {
  const { useCondensedLayout } = usePresentation();
  const { data, error, loading } = useProductDeprecated({ itemId, domains: ['identifiers', 'info', 'reviews'] });
  if ((error && !data) || !data || loading) {
    return null;
  }
  const seoLink = `${data?.product?.identifiers?.canonicalUrl?.replace('/p', '/p/reviews') || ''}/1`;
  const { product } = data || {};
  const { reviews } = product || {};
  const totalReviews = reviews?.ratingsReviews?.totalReviews || 0;
  const averageRating = reviews?.ratingsReviews?.averageRating || 0;
  const {
    averageOverallRating, ratingDistribution, recommendationPercentage, secondaryRatingsAverages = [], totalReviewCount
  } = reviewStatistics;

  // Use BV as primary but fallback to available product data
  const total = totalReviewCount || totalReviews;
  const totalWithCommas = ReviewHelper.numberWithCommas(total);
  const average = averageOverallRating || Number(averageRating).toFixed(1);
  const writeAReviewClass = classNames({
    'ratings-and-reviews-overview__desktop__write-review': !isMobileOverlay,
    'ratings-and-reviews-overview__mobile-overlay__write-review': isMobileOverlay,
  });
  return (
    <Row>
      {!useCondensedLayout
      && (
        <Col xs="3" className="flex">
          <ul className="ratings-and-reviews-overview__desktop__list">
            <li>
              <div>
                <span className="ratings-and-reviews-overview__desktop__list__review-average">{average} </span>
                <span className="ratings-and-reviews-overview__desktop__list__review-stars">
                  <Rating titleEnabled value={Number(average)} />
                  <span className="ratings-and-reviews-overview__desktop__list__review-totals">{`out of ${totalWithCommas} reviews`}</span>
                </span>
              </div>
            </li>
            {[null, undefined].indexOf(recommendationPercentage) === -1 &&
            <li className="ratings-and-reviews-overview__desktop__list__recommend-wrapper">
              <span
                className="ratings-and-reviews-overview__desktop__list__float-left__recommend-percentage">{recommendationPercentage}% </span>
              <span
                className="ratings-and-reviews-overview__desktop__list__float-left__recommend-customers-text">recommend this product</span>
            </li>
            }
          </ul>
        </Col>
      )}
      {useCondensedLayout
      && (
        <RatingsAndReviewsMobileHeader average={average} total={total} recommendationPercentage={recommendationPercentage} />
      )}
      {(ratingDistribution || []).length > 0
      && (
        <Col xs={!useCondensedLayout ? '6' : '12'}>
          <Histogram
            totalReviews={total}
            ratings={ratingDistribution}
            clickableFilters={!useCondensedLayout}
            onFilterChange={onFilterChange}
            filterCheckboxes={filterCheckboxes}
            clickableFilters={clickableFilters}
            selectedSentiment={selectedSentiment}
          />
        </Col>
      )}
      {!useCondensedLayout &&
        <Col
          fallback="12"
          xs="3"
        >
          <div className={writeAReviewClass}>
            <WriteAReview
            apiKey={apiKey}
            reviewStatistics={reviewStatistics}
            itemId={itemId}
            className="overview"
            />
          </div>
        </Col>
      }
      {useCondensedLayout &&
        <Col
          fallback={isMobileOverlay ? '12' : '6'}
          sm="6"
          xs={isMobileOverlay ? '12' : '6'}
        >
          <div className={writeAReviewClass}>
            <WriteAReview
              apiKey={apiKey}
              reviewStatistics={reviewStatistics}
              itemId={itemId}
              className="overview"
            />
          </div>
        </Col>
      }
      {useCondensedLayout && !isMobileOverlay &&
        <Col fallback='6' xs='6'>
          <div className="ratings-and-reviews-overview__desktop__write-review">
              <Button onClick={() => handleCardClick()}>
                <a className="seo_link" onClick={(evt)=> evt.preventDefault()} href={`${seoLink}`}>
                  See All Reviews
                </a>
              </Button>
          </div>
        </Col>
      }
    </Row>
  );
};

Overview.displayName = 'RatingsAndReviewsOverview';

Overview.propTypes = {
  apiKey: string.isRequired,
  handleCardClick: func,
  isMobileOverlay: bool,
  reviewStatistics: instanceOf(Object).isRequired,
  hideSecondaryRatings: bool
};

Overview.defaultProps = {
  handleCardClick: ()=>{},
  isMobileOverlay: false,
  hideSecondaryRatings: false
};

Overview.dataModel = dataModel;
